/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4DiagMinIcon32Regular = forwardRef('ArrowDim4DiagMinIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M4.707 3.293a1 1 0 0 0-1.414 1.414L10.586 12H4a1 1 0 1 0 0 2h7a3 3 0 0 0 3-3V4a1 1 0 1 0-2 0v6.586L4.707 3.293Z" }),
        React.createElement("path", { d: "M28.707 4.707 21.414 12H28a1 1 0 1 1 0 2h-7a3 3 0 0 1-3-3V4a1 1 0 1 1 2 0v6.586l7.293-7.293a1 1 0 1 1 1.414 1.414Z" }),
        React.createElement("path", { d: "M10.586 20H4a1 1 0 1 1 0-2h7a3 3 0 0 1 3 3v7a1 1 0 1 1-2 0v-6.586l-7.293 7.293a1 1 0 0 1-1.414-1.414L10.586 20Z" }),
        React.createElement("path", { d: "M28 20h-6.586l7.293 7.293a1 1 0 0 1-1.414 1.414L20 21.414V28a1 1 0 1 1-2 0v-7a3 3 0 0 1 3-3h7a1 1 0 1 1 0 2Z" })));
});
